import { compose, setDisplayName, setPropTypes } from 'react-recompose';
import { func, oneOfType, object } from 'prop-types';
import { connect } from 'react-redux';
import toJS from './toJS.jsx';


const propTypes = {
    mapStateToProps: func,
    mapDispatchToProps: oneOfType([func, object]),
};

export default ({ mapStateToProps = null, mapDispatchToProps = null }) => compose(
    setDisplayName('withReduxConnect'),
    setPropTypes(propTypes),
    connect(mapStateToProps, mapDispatchToProps),
    toJS,
);

